export default __webpack_public_path__ + "static/media/AutenticaID.73998e59.svg";